// extracted by mini-css-extract-plugin
export default {"userDetailWrapper":"userDetail_userDetailWrapper__Ua+Xy","pageTitle":"userDetail_pageTitle__b7QR5"};